import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import styled from "styled-components";
import LineBtn from "../../../components/Button/LineBtn";
import Blank from "../../../components/DefaultStyles/Blank";
import ChildPageNav from "../../../components/DefaultStyles/ChildPageNav";
import LineBox from "../../../components/DefaultStyles/LineBox";
import PageTitle from "../../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../../components/DefaultStyles/SpaceBetween";
import TitleWithLine from "../../../components/DefaultStyles/TitleWithLine";
import SunsetAlimtalk, {
  notiCaseSaveState,
} from "../../../components/pages/Manage/Sunset/SunsetAlimtalk/SunsetAlimtalk";
import SunsetDetailInfo from "../../../components/pages/Manage/Sunset/SunsetDetail/SunsetDetailInfo";
import SunsetDetailButtons, {
  sunsetDetailButtonType,
} from "../../../components/pages/Manage/Sunset/SunsetDetailButtons";
import useMy from "../../../hooks/useMy";
import { ISunset } from "./Sunset";
import AlertModal from "../../../components/Modal/AlertModal";
import ConfirmBtn from "../../../components/Button/ConfirmBtn";
import { sunsetDetailDataState } from "../../../components/pages/Manage/Sunset/SunsetDetail/SunsetSubs";

interface ISunsetData {
  state: {
    sunsetData: ISunset;
  };
}

export default function SunsetDetail() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);
  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );
  const setNotiCaseSave = useSetRecoilState(notiCaseSaveState);

  console.log(location);

  const { name } = useMy();

  const [editAskModal, setEditAskModal] = useState(false);
  const [showAlimTalk, setShowAlimTalk] = useState(true);

  useEffect(() => {
    if (buttonType === "input") {
      setSunsetDetailData({
        sunsetSubsId: 0,
        sunriseSubsId: 0,
        sunsetParty: "",
        sunsetType: 0,
        notifyType: 0,
        sunsetDate: "",
        sunriseDate: "",
        notifyDate: "",
        sunsetReason: "",
      });

      setNotiCaseSave({
        matchingWaiting: false,
        before: false,
        underMonth: false,
        overMonthOwner: false,
        overMonthMember: false,
      });

      setShowAlimTalk(false);
    } else if (
      (buttonType === "view" || buttonType === "edit") &&
      location?.state
    ) {
      setSunsetDetailData({
        sunsetSubsId: location?.state?.sunsetData?.ssetSubs ?? 0,
        sunriseSubsId: location?.state?.sunsetData?.srisSubs ?? 0,
        sunsetParty: location?.state
          ? location?.state?.sunsetData?.ssetParty?.length > 0
            ? location?.state?.sunsetData?.ssetParty.toString()
            : location?.state?.sunsetData?.ssetParty?.length === 0
            ? "0"
            : ""
          : "",
        sunsetType: location?.state?.sunsetData?.ssetType ?? 0,
        notifyType: location?.state?.sunsetData?.notifyType ?? 0,
        sunsetDate: location?.state
          ? dayjs(location?.state?.sunsetData?.ssetDate).format("YYYY-MM-DD")
          : "",
        sunriseDate: location?.state
          ? dayjs(location?.state?.sunsetData?.sriseDate).format("YYYY-MM-DD")
          : "",
        notifyDate: location?.state
          ? dayjs(location?.state?.sunsetData?.notifyDate).format("YYYY-MM-DD")
          : "",
        sunsetReason: location?.state
          ? location?.state?.sunsetData?.customvar?.alertcat ?? ""
          : "",
      });
      setNotiCaseSave({
        matchingWaiting: false,
        before: false,
        underMonth: false,
        overMonthOwner: false,
        overMonthMember: false,
      });
    }
  }, []);

  useEffect(() => {
    console.log(buttonType);
  }, [buttonType]);

  return (
    <>
      <SpaceBetween>
        <>
          <PageTitle
            title={buttonType === "input" ? "일몰 설정하기" : "일몰 상세"}
            route="/linkid-manage/sunset"
          />

          <ChildPageNav
            parentRoute="/linkid-manage/sunset"
            childPageTitle={
              buttonType === "input" ? "일몰 설정하기" : "일몰 상세"
            }
          />
        </>
      </SpaceBetween>

      <SunsetDetailContainer>
        <LineBox
          style={{
            marginRight: 20,
            minWidth: 400,
            maxWidth: 540,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
          boxPadding="28px 40px 24px 40px"
        >
          <div>
            <TitleWithLine title="1. 일몰 설정" />

            <Blank blankHeight={24} />

            <TableBorder />

            <SunsetDetailInfo />

            <TableBorder />
          </div>

          <>
            {buttonType !== "view" && (
              <ButtonContainer>
                {buttonType === "input" && !showAlimTalk ? (
                  <ConfirmBtn
                    btnText="확인"
                    btnColor="mint"
                    isDisabled={
                      sunsetDetailData?.sunsetSubsId === 0 ||
                      sunsetDetailData?.sunriseSubsId === 0 ||
                      sunsetDetailData?.sunsetDate === "" ||
                      sunsetDetailData?.sunsetType === 0 ||
                      sunsetDetailData?.notifyDate === "" ||
                      sunsetDetailData?.notifyType === 0 ||
                      sunsetDetailData?.sunsetReason === "" ||
                      sunsetDetailData?.sunsetParty === ""
                    }
                    btnClickEvent={() => {
                      setShowAlimTalk(true);
                    }}
                  />
                ) : (
                  <LineBtn
                    btnText="수정하기"
                    btnColor="mint"
                    btnClickEvent={() => setEditAskModal(true)}
                  />
                )}
              </ButtonContainer>
            )}
          </>
        </LineBox>

        {showAlimTalk ? (
          <LineBox boxPadding="28px 40px 24px 40px">
            <TitleWithLine title="2. 통지 내용 확인" />

            <Blank blankHeight={24} />
            <TableBorder />

            <SunsetAlimtalk />
          </LineBox>
        ) : (
          <div />
        )}
      </SunsetDetailContainer>

      <Footer>
        <Manager>
          {location?.state?.sunsetData?.indate !== ""
            ? dayjs(location?.state?.sunsetData?.indate).format(
                "YYYY.MM.DD (dd)"
              )
            : dayjs().format("YYYY.MM.DD (dd)")}{" "}
          <br />
          관리자:{" "}
          {location?.state?.sunsetData?.writer !== ""
            ? location?.state?.sunsetData?.writer ?? name
            : name}
        </Manager>

        <SunsetDetailButtons />
      </Footer>

      {editAskModal && (
        <AlertModal
          title={`일몰 설정을 수정하면 기존에 입력한 
통지 내용은 삭제됩니다.
계속 하시겠습니까?`}
          confirmText={"수정"}
          btnColor="mint"
          cancelEvent={() => setEditAskModal(false)}
          confirmEvent={() => {
            setShowAlimTalk(false);
            setEditAskModal(false);
          }}
        />
      )}
    </>
  );
}

const SunsetDetailContainer = styled.div`
  display: flex;
`;

export const TableBorder = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) => theme.buttonColor.lineNormal};
`;

const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
`;

const Manager = styled.div`
  font-size: 13px;
  line-height: 19.5px;
  text-align: left;
  color: #9a9fa8;
`;

const ButtonContainer = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
